import { ISurveyFormProps, SurveyForm } from "../../components/Survey/SurveyForm";

export type NewRiskProps = Pick<ISurveyFormProps, "onSubmit" | "getOrganizations">

function NewRisk({ onSubmit, getOrganizations }: NewRiskProps) {
    return <SurveyForm title="Skrá svör við spurningarlista" onSubmit={onSubmit} getOrganizations={getOrganizations} />;
}

export default NewRisk;
